import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { Section as MenuSection } from '@atlaskit/menu';
import { sectionHeaderSpacingStyles } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
const Section = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    shouldRender
  } = useShouldNestedElementRender();
  if (!shouldRender) {
    return props.children;
  }
  return /*#__PURE__*/React.createElement(MenuSection, _extends({}, props, {
    ref: ref
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    ,
    overrides: {
      HeadingItem: {
        cssFn: sectionHeaderSpacingStyles
      }
    }
  }));
});
export default Section;